<template>

        <select class="form-control Pointer" :disabled="disabled" @change="changeSelect" v-model="selectedValue" v-if="render">
            <option v-if="defaultItemId == null || defaultItemId == 0" disabled selected value>گزینه مد نظر را انتخاب نمایید</option>
            <option v-for="item in options" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
        </select>

</template>


<script>
export default {
    data() {
        return {
            options: null,
            selectedValue: null,
            render: true,
            defaultItem: null
        }
    },
    props: {
        grp: Number,
        disabled: {
            type: Boolean,
            default: false
        },
        defaultItemId: {
            type: Number,
            default: null
        }
    
    },
    mounted() {
        this.getCombo()
    },
    methods: {
        changeSelect(){
            let value = this.options.find(x=> x.id == this.selectedValue)
            this.$emit('result', value);
        },
        getCombo() {
            let action = 'ComboGrp/' + this.grp
            this.$PostData_new(action, 'get').then((res) => {
                this.options = res
                this.render = false
                this.$nextTick(() => {
                    this.render = true
                });
            })
        }
    },
    watch: {
    defaultItemId(newValue) {
      this.selectedValue = newValue;
    }
  }
}

</script>